/*
 *@Description: 敏感词校验
 *@param
 *@return
*/
import { getHandlingOpinionsMsg } from '@views/pool'
import { RESPONSE_CODE } from '@public/http/config';

export default {
  data() {
    return {
      handlingOpinionsMsg: ''// 处理意见 校验文字
    }
  },

  methods: {
    // 处理意见 校验
    // 入参为校验文字
    handlingOpinionsValidate(handleMsg = 'handlingOpinionsMsg') {
      return (rule, value, callback) => {
        if (this[handleMsg]) {
          callback(new Error(this[handleMsg]))
        } else {
          callback()
        }
      }
    },
    // opinionMsg--入参 handleMsg--校验文字
    async getHandlingOpinionsMsg(opinionMsg, handleMsg = 'handlingOpinionsMsg') {
      if (!opinionMsg) return false
      try {
          //当校验不通过时 fail为true
        const { code, msg ,data} = await getHandlingOpinionsMsg(opinionMsg)
        if (code === RESPONSE_CODE.SUCCESS && !data) {
          this[handleMsg] = msg
          return true
        }
        return false
      } catch (err) {
        console.log(err);
        return false
      }
    }
  }
}
